import { render, staticRenderFns } from "./ProductCardLeaflet.vue?vue&type=template&id=1aedc8f0"
import script from "./ProductCardLeaflet.vue?vue&type=script&lang=js"
export * from "./ProductCardLeaflet.vue?vue&type=script&lang=js"
import style0 from "./ProductCardLeaflet.vue?vue&type=style&index=0&id=1aedc8f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports